document.addEventListener("turbo:load", function () {
  setupPdfNavigation();
});

document.addEventListener("turbo:frame-render", function (event) {
  if (event.target.id === "pdf-viewer") {
    setupPdfNavigation();
  }
});

function setupPdfNavigation() {
  const container = document.getElementById("pdf-viewer-container");
  if (!container) return;

  const currentPage = parseInt(container.dataset.currentPage);
  const totalPages = parseInt(container.dataset.totalPages);
  const variantId = container.dataset.variantId;

  updatePageInUrl(currentPage);

  document.querySelectorAll(".page-input").forEach(input => {
    input.value = currentPage;

    const newInput = input.cloneNode(true);
    input.parentNode.replaceChild(newInput, input);

    newInput.addEventListener("change", function () {
      const page = parseInt(this.value);
      if (page > 0 && page <= totalPages) {
        this.form.requestSubmit();
      } else {
        this.value = currentPage;
      }
    });
  });

  updateNavButtons(currentPage, totalPages, variantId);
}

function updateNavButtons(currentPage, totalPages, variantId) {
  const prevButtons = document.querySelectorAll(".prev-page");
  const nextButtons = document.querySelectorAll(".next-page");

  prevButtons.forEach(btn => {
    const newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);

    if (currentPage <= 1) {
      newBtn.classList.add("disabled");
    } else {
      newBtn.classList.remove("disabled");
      const prevPage = Math.max(1, currentPage - 1);
      newBtn.href = `/access_resources/${variantId}?page=${prevPage}`;
    }
  });

  nextButtons.forEach(btn => {
    const newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);

    if (currentPage >= totalPages) {
      newBtn.classList.add("disabled");
    } else {
      newBtn.classList.remove("disabled");
      const nextPage = Math.min(totalPages, currentPage + 1);
      newBtn.href = `/access_resources/${variantId}?page=${nextPage}`;
    }
  });
}

function updatePageInUrl(pageNumber) {
  const url = new URL(window.location);
  url.searchParams.set("page", pageNumber);
  history.replaceState({}, "", url);
}
